import {css} from '@emotion/react';
import styled from '@emotion/styled';
import {mixinFlexboxColumn, mixinOverflow} from 'webapp-lib/styling';

const mixinFieldsWrapper = css`
  display: flex;
  flex-direction: column;
  gap: var(--gutter);
`;

const mixinOuterSpacing = css`
  padding: var(--gutter-tiny) 150px;
`;

export const FormColumn = styled.div`
  ${mixinFieldsWrapper};
`;

export const StyledFillPlaceholders = styled.div`
  width: 100%;
  ${mixinOuterSpacing};
  ${mixinOverflow};

  &::-webkit-scrollbar-thumb {
    visibility: visible;
  }
`;

export const StyledDoubleColumnFillPlaceholders = styled.div`
  width: 100%;
  padding: var(--gutter-tiny) 0;

  &.single-column {
    ${mixinOuterSpacing};
  }

  ${mixinOverflow}
  &::-webkit-scrollbar-thumb {
    visibility: visible;
  }
`;

export const AddressFieldWrapper = styled.div`
  ${mixinFlexboxColumn};
  gap: var(--gutter-little);
`;

export const StyledFieldset = styled.fieldset`
  ${mixinFieldsWrapper};
  border: none; // remove default fieldset border
  margin: 0; // remove default fieldset margin
  padding: 0; // remove default fieldset padding

  legend {
    color: var(--color-core-primary);
    font-size: var(--font-size-subsubtitle);
    margin-bottom: var(--gutter);
    padding: 0; // remove default legend padding
  }
`;
